import { Doc } from "@/components/Doc/Doc";
import { LabelExplainer } from "@/components/LabelExplainer/LabelExplainer";
import { buyersWCAdjustmentAtom } from "@/financeModels/owasco/workingCapital";
import { Stack } from "@mantine/core";
import { useAtomValue } from "jotai";
import { TbMoneybag } from "react-icons/tb";
import {
  ComputedDollarResult,
  ComputedResultContainer,
  ComputedResultLine,
} from "../../Sidebar/ComputedResult";

const Panel = () => {
  const adjustment = useAtomValue(buyersWCAdjustmentAtom);

  return (
    <Stack gap={4}>
      <ComputedResultContainer>
        <ComputedResultLine
          label={
            <LabelExplainer
              label="NWC Peg"
              explanation={
                <Doc path="@/docs/pages/model/working-capital/sidebar/buyer-wc-adjustment.mdx" />
              }
            />
          }
          value={<ComputedDollarResult value={adjustment} />}
        />
      </ComputedResultContainer>
    </Stack>
  );
};

export const ModuleBuyers = {
  key: "Buyer's Working Capital",
  icon: <TbMoneybag />,
  control: "Buyer's Working Capital",
  panel: <Panel />,
};
